import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';
import NumberFormat from 'react-number-format';
import { AvField } from 'availity-reactstrap-validation';
import { Card, CardBody, Col, Container, Row, Button, FormGroup } from 'reactstrap';
import filterFactory from 'react-bootstrap-table2-filter';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import { Package, CircleUser, Handshake, Receipt, CheckCircle, AlertCircle } from 'lucide-react';
import danger from '../../assets/images/danger.png';
import { showToast } from '../../components/Toast';
import { currentDateForTransfer } from '../../helpers/current_date_helper';
import { transfersEuropeApi } from '../../services/TransfersService';
import PageLoader from '../../components/Loaders/newPageLoader';
import { motion, AnimatePresence } from 'framer-motion';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import ExcelJS from 'exceljs';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { socket } from '../../app-socket/socket';
import { WsEvents } from '../../app-socket/events';
import { onAddTransfer, onUpdateTransfer, onDeleteTransfer } from '../../app-socket/events/transfer';
import { fetchTrackingStatuses } from '../../api/trackingApi';
import TrackingColumnPrTest from '../../components/TrackingColumnPrTest';
import useLoadingProgress from '../../hooks/useLoadingProgress';
import { MainContent } from '../../components/Table/MainContent';

export default function PriorityUsa({ profileData }) {
  const dispatch = useDispatch();
  // const {
  //   data: baseData,
  //   isFetching: isLoadingBase,
  //   error,
  //   refetch,
  // } = transfersEuropeApi.useFetchLatestTransfersQuery(profileData._id, {
  //   refetchOnMountOrArgChange: false,
  //   refetchOnFocus: false,
  // });
  // const [getTransfers, { data: unfilteredData, isFetching: isLoadingUnfiltered }] = transfersEuropeApi.useLazyFetchLatestTransfersQuery();
  // const [getFilteredTransfers, { data: filteredData, isFetching: isLoadingFiltered }] = transfersEuropeApi.useLazyFilterTransfersQuery();

  const { progress, step, visible } = useLoadingProgress({
    // isLoading: loading,
    // isFetching: loading,
    // isLoadingUnfiltered,
    // isLoadingFiltered,
  });

  const [cardHeight, setCardHeight] = useState(0);
  const cardRef = useRef(null);
  useEffect(() => {
    if (!cardRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        if (newHeight > 0) setCardHeight(newHeight);
      }
    });
    resizeObserver.observe(cardRef.current);
    return () => resizeObserver.disconnect();
  }, []);
  const [visitedTabs, setVisitedTabs] = useState(new Set([1]));
  const [activeTab, setActiveTab] = useState(1);
  const activeTabRef = useRef(activeTab);

  const tabs = [
    { id: 1, label: 'GLS', icon: 'mdi-box' },
    { id: 2, label: 'PGMC', icon: 'mdi-box-cutter' },
  ];

  return (
    <React.Fragment>
      <PageLoader progress={progress} step={step} visible={visible} />
      <div className='page-content'>
        <MetaTags>
          <title>Priority USA</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title='Korupharma' breadcrumbItem='Priority USA' />
          <Row className='card-section'>
            <Col lg='12'>
              <div className='pcss3t logtb pcss3t-effect-scale pcss3t-theme-1'>
                {tabs.map((tab) => (
                  <React.Fragment key={tab.id}>
                    <input type='radio' name='pcss3t' id={`tab${tab.id}`} checked={activeTab === tab.id} onChange={() => setActiveTab(tab.id)} className={`tab-content-${tab.id}`} />
                    <label htmlFor={`tab${tab.id}`}>
                      <i className={`mdi ${tab.icon}`}></i> {tab.label}
                    </label>
                  </React.Fragment>
                ))}
                <ul>
                  <AnimatePresence key='1' exitBeforeEnter>
                    <motion.li
                      className={`tab-content tab-content-1 typography`}
                      initial={{ opacity: 0, x: 30 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -30 }}
                      transition={{ duration: 0.3 }}
                      style={{ display: 'block' }}
                    >
                      <div id='card-section' ref={cardRef}>
                        <Row className='card-section'>
                          <Col lg='12'>
                            <Card>
                              <CardBody className='cardBodySticky'>
                                {/* <ToolkitProvider keyField='_id' columns={columns} data={data} search>
                                  {(props) => (
                                    <React.Fragment>

                                    </React.Fragment>
                                  )}
                                </ToolkitProvider> */}
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </motion.li>
                  </AnimatePresence>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}